module.exports = __webpack_public_path__ + "static/media/family_office-bg.649ef166.jpg";